import { filter, first, get, map } from "lodash";
import { AgGridUserPreference, UserSelection } from "./userPreference.typings";

export const MapToAgGridUserPreference = (
  userSelection: UserSelection
): AgGridUserPreference => {
  if (userSelection) {
    if (userSelection.gridState) {
      const gridState = JSON.parse(userSelection.gridState);
      return {
        columns: gridState.columnState,
        sort: gridState.sortModel,
        filter: gridState.filterModel,
      };
    }
    if (userSelection.columns) {
      return userSelection as AgGridUserPreference;
    }
  }
  return { columns: [] };
};

export const getFieldInformations = (
  referential: any[],
  properties: string[],
  field: string
): string[] => {
  const result: string[] = map(properties, property => {
    const propertyInfo = first(
      filter(
        referential,
        item => item.headerName === property || item.field === property
      )
    );
    return propertyInfo ? get(propertyInfo, field) : "";
  });
  return result.filter(elem => elem);
};
